import React from 'react';
import { format as formatDate, parse as parseDate, } from 'date-fns';
import numeral from 'numeral';

import { types, ownerTypes, } from '../shared/models/expense';
import { timeline, changedFieldNames, valueFieldNames, } from '../shared/models/recurringExpense';
import ModalButton from './ModalButton';

const fieldLabels = {
  ownerType: '種別',
  ownerId: 'ショップ',
  type: '費目',
  description: '内容',
  amount: '金額',
};

const timelineKindLabels = {
  start: '開始',
  from: 'この月以降',
  only: 'この月のみ',
  skip: 'この月のみ',
  end: '終了',
};

const formatMonth = _ => formatDate(parseDate(_, 'yyyy-MM', new Date()), 'yyyy年M月');

export default function RecurringExpenseHistoryButton({ recurringExpense, ownersById, ...extraProps }) {
  const formatValue = (fieldName, value) => ({
    ownerType: _ => ownerTypes[_]?.label,
    ownerId: _ => ownersById[_]?.name,
    type: _ => types[_]?.label,
    amount: _ => _ != null ? `${numeral(_).format()}円` : null,
  }[fieldName] || (_ => _))(value) ?? '-';
  const renderDiff = (before, after) => (
    changedFieldNames(before, after).map(_ => (
      <div key={_}>
        {fieldLabels[_]}: {formatValue(_, before?.[_])} → {formatValue(_, after?.[_])}
      </div>
    ))
  );
  const renderValues = values => (
    valueFieldNames.map(_ => (
      <div key={_}>
        {fieldLabels[_]}: {formatValue(_, values?.[_])}
      </div>
    ))
  );
  const renderTimelineContent = ({ kind, before, after }) => ({
    start: () => renderValues(after),
    from: () => renderDiff(before, after),
    only: () => renderDiff(before, after),
    skip: () => '計上なし',
    end: () => 'この月で終了',
  })[kind]();

  return (
    <ModalButton
      title="毎月の経費の履歴"
      label="履歴"
      color="link"
      size="sm"
      outline={false}
      className="p-0 ms-1 align-baseline"
      content={_ => (
        <div>
          <table className="table table-bordered table-sm">
            <thead className="text-nowrap">
              <tr>
                <th style={{ width: 110 }}>年月</th>
                <th style={{ width: 110 }}>適用</th>
                <th>内容</th>
              </tr>
            </thead>
            <tbody>
              {
                timeline(recurringExpense).map((entry) => (
                  <tr key={`${entry.month}-${entry.kind}`}>
                    <td className="text-nowrap">{formatMonth(entry.month)}</td>
                    <td className="text-nowrap">{timelineKindLabels[entry.kind]}</td>
                    <td>{renderTimelineContent(entry)}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      )}
      {...extraProps}
    />
  );
};
